import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

// BUG FIX (navigation follow-up, ask #1 — "Android back button"): Capacitor
// does NOT wire the hardware/gesture back button to browser history on its
// own — with no listener registered at all (the previous state of this
// app), every back press either does nothing or exits the app immediately,
// regardless of where the user actually is. Registering this listener is
// what makes the back button "follow history" in the first place.
//
// canGoBack (from the native WebView's own navigation stack, which includes
// every pushState navigate() call — React Router tab/drawer history
// included) means there's somewhere IN-APP to go back to: close an open
// drawer/tab/modal that's URL-tracked (JobDetail's tabs, the Prospects/
// Leads drawers, Proposals' tabs — see those files) exactly the same way a
// web Back press already does, one step at a time. !canGoBack means the
// user is at the start of their in-app history — in practice the first
// screen they landed on after login (the dashboard, for the common case) —
// so only THEN does back exit the app, matching "only exit from the home
// screen" rather than at an arbitrary point.
//
// Native only: web browsers already drive their own hardware/gesture back
// correctly without any of this.
export default function useNativeBackButton() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;
    let handle;
    (async () => {
      const { App: CapacitorApp } = await import('@capacitor/app');
      handle = await CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) window.history.back();
        else CapacitorApp.exitApp();
      });
    })();
    return () => { if (handle) handle.remove(); };
  }, []);
}
